import request from '@/middleware/request'

const getInitialDashboard = page => {
  return request({
    url: `/dashboard/initial/${page}`,
    method: 'get'
  })
}

/////////////////////////////// Voice ///////////////////////////////
const getVoiceSession = data => {
  return request({
    url: '/dashboard/voice_session',
    method: 'post',
    data
  })
}
const getVoiceOffload = data => {
  return request({
    url: '/dashboard/voice_offload',
    method: 'post',
    data
  })
}
const getVoiceServiceSuccess = data => {
  return request({
    url: '/dashboard/voice_service_success',
    method: 'post',
    data
  })
}

const getVoiceResult = data => {
  return request({
    url: '/dashboard/voice_result',
    method: 'post',
    data
  })
}

const getVoiceHourly = data => {
  return request({
    url: '/dashboard/voice_hourly',
    method: 'post',
    data
  })
}

const getVoiceVolume = data => {
  return request({
    url: '/dashboard/voice_volume',
    method: 'post',
    data
  })
}

const getVoiceServiceType = data => {
  return request({
    url: '/dashboard/voice_service_type',
    method: 'post',
    data
  })
}

const getVoiceIntent = data => {
  return request({
    url: '/dashboard/voice_intent',
    method: 'post',
    data
  })
}

const getVoiceTopFaq = data => {
  return request({
    url: '/dashboard/voice_top_faq',
    method: 'post',
    data
  })
}

const getVoiceTopSelfService = data => {
  return request({
    url: '/dashboard/voice_top_self_service',
    method: 'post',
    data
  })
}

const getVoiceTopTransfer = data => {
  return request({
    url: '/dashboard/voice_top_transfer',
    method: 'post',
    data
  })
}

const getTagCloud = data => {
  return request({
    url: '/dashboard/tag_cloud',
    method: 'post',
    data
  })
}

const getConcurrent = data => {
  return request({
    url: '/dashboard/concurrent',
    method: 'post',
    data
  })
}

const getVoiceSessionSuccess = data => {
  return request({
    url: '/dashboard/voice_session_success',
    method: 'post',
    data
  })
}
const getVoiceCustomer = data => {
  return request({
    url: '/dashboard/voice_customer',
    method: 'post',
    data
  })
}
const getVoiceTransfer = data => {
  return request({
    url: '/dashboard/voice_transfer',
    method: 'post',
    data
  })
}
const getVoiceByChannel = data => {
  return request({
    url: '/dashboard/voice_by_channel',
    method: 'post',
    data
  })
}

const getVoiceCompareSessionOffload = data => {
  return request({
    url: '/dashboard/voice_compare_session_offload',
    method: 'post',
    data
  })
}
const getVoiceCampaign = data => {
  return request({
    url: '/dashboard/voice_campaign',
    method: 'post',
    data
  })
}
const getVoiceCompareSessionSuccess = data => {
  return request({
    url: '/dashboard/voice_compare_session_success',
    method: 'post',
    data
  })
}

/////////////////////// Outbound ///////////////////////
const getVoiceCall = data => {
  return request({
    url: '/dashboard/voice_call',
    method: 'post',
    data
  })
}
const getVoiceAnsweredCall = data => {
  return request({
    url: '/dashboard/voice_answered_call',
    method: 'post',
    data
  })
}

// const getVoiceHangup = data => {
//   return request({
//     url: '/dashboard/voice_hangup',
//     method: 'post',
//     data
//   })
// }
// const getVoiceConversation = data => {
//   return request({
//     url: '/dashboard/voice_conversation',
//     method: 'post',
//     data
//   })
// }

// const getVoiceActive = () => {
//   return request({
//     url: '/dashboard/voice_active',
//     method: 'get'
//   })
// }

// const getVoiceByDestination = data => {
//   return request({
//     url: '/dashboard/voice_by_destination',
//     method: 'post',
//     data
//   })
// }
// const getVoiceByIntent = data => {
//   return request({
//     url: '/dashboard/voice_by_intent',
//     method: 'post',
//     data
//   })
// }
// const getVoiceChatActive = data => {
//   return request({
//     url: '/dashboard/voice_chat_active',
//     method: 'post',
//     data
//   })
// }
// const getVoiceTagCloud = data => {
//   return request({
//     url: '/dashboard/voice_tag_cloud',
//     method: 'post',
//     data
//   })
// }
// const getVoiceCompareSessionCustomer = data => {
//   return request({
//     url: '/dashboard/voice_compare_session_customer',
//     method: 'post',
//     data
//   })
// }
// const getVoiceCompareSessionSuccess = data => {
//   return request({
//     url: '/dashboard/voice_compare_session_success',
//     method: 'post',
//     data
//   })
// }

/////////////////////////////// Chat ///////////////////////////////
const getChatSession = data => {
  return request({
    url: '/dashboard/chat_session',
    method: 'post',
    data
  })
}
const getChatSessionSuccess = data => {
  return request({
    url: '/dashboard/chat_session_success',
    method: 'post',
    data
  })
}

const getChatCustomer = data => {
  return request({
    url: '/dashboard/chat_customer',
    method: 'post',
    data
  })
}
const getChatTransfer = data => {
  return request({
    url: '/dashboard/chat_transfer',
    method: 'post',
    data
  })
}
const getChatByChannel = data => {
  return request({
    url: '/dashboard/chat_by_channel',
    method: 'post',
    data
  })
}
const getChatHourly = data => {
  return request({
    url: '/dashboard/chat_hourly',
    method: 'post',
    data
  })
}
const getChatCompareSessionOffload = data => {
  return request({
    url: '/dashboard/chat_compare_session_offload',
    method: 'post',
    data
  })
}

// const getChatServiceSuccess = data => {
//   return request({
//     url: '/dashboard/chat_service_success',
//     method: 'post',
//     data
//   })
// }
// const getChatHangup = data => {
//   return request({
//     url: '/dashboard/chat_hangup',
//     method: 'post',
//     data
//   })
// }
// const getChatActive = () => {
//   return request({
//     url: '/dashboard/chat_active',
//     method: 'get'
//   })
// }
// const getChatConversation = data => {
//   return request({
//     url: '/dashboard/chat_conversation',
//     method: 'post',
//     data
//   })
// }
// const getChatByDestination = data => {
//   return request({
//     url: '/dashboard/chat_by_destination',
//     method: 'post',
//     data
//   })
// }
// const getChatByIntent = data => {
//   return request({
//     url: '/dashboard/chat_by_intent',
//     method: 'post',
//     data
//   })
// }

// const getChatTagCloud = data => {
//   return request({
//     url: '/dashboard/chat_tag_cloud',
//     method: 'post',
//     data
//   })
// }
// const getChatCompareSessionCustomer = data => {
//   return request({
//     url: '/dashboard/chat_compare_session_customer',
//     method: 'post',
//     data
//   })
// }

// const getChatCompareSessionSuccess = data => {
//   return request({
//     url: '/dashboard/chat_compare_session_success',
//     method: 'post',
//     data
//   })
// }

export default {
  getInitialDashboard,

  getVoiceSession,
  getVoiceOffload,
  getVoiceServiceSuccess,
  getVoiceResult,
  getVoiceVolume,
  getVoiceServiceType,
  getVoiceIntent,
  getVoiceTopFaq,
  getVoiceTopSelfService,
  getVoiceTopTransfer,
  getTagCloud,
  getConcurrent,

  getVoiceSessionSuccess,
  getVoiceCustomer,
  getVoiceTransfer,
  getVoiceByChannel,
  getVoiceHourly,
  getVoiceCompareSessionOffload,
  getVoiceCampaign,
  getVoiceCompareSessionSuccess,

  getVoiceCall,
  getVoiceAnsweredCall,

  // getVoiceHangup,
  // getVoiceConversation,

  // getVoiceActive,
  // getVoiceByDestination,
  // getVoiceByIntent,

  // getVoiceChatActive,

  // getVoiceTagCloud,
  // getVoiceCompareSessionCustomer,
  // getVoiceCompareSessionSuccess,

  getChatSession,
  getChatCustomer,
  getChatSessionSuccess,
  getChatTransfer,
  getChatByChannel,
  getChatHourly,
  getChatCompareSessionOffload

  // getChatConversation,
  // getChatHangup,
  // getChatServiceSuccess,

  // getChatActive,
  // getChatByDestination,
  // getChatByIntent,

  // getChatTagCloud,
  // getChatCompareSessionCustomer,
  // getChatCompareSessionSuccess
}
